import { watchEffect, ref } from "@vue/composition-api";
export const useActiveLink = (ctx) => {
  let path = ref("");

  watchEffect(() => {
    path.value = ctx.root.$route.path;
  });

  const active = (p) => {
    return path.value.indexOf(p) === 0;
  };

  return { active };
};
